import { render, staticRenderFns } from "./k-flow-formInfo.vue?vue&type=template&id=25537406"
import script from "./k-flow-formInfo.vue?vue&type=script&lang=js"
export * from "./k-flow-formInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports